import moment from "moment";
import Modal from "react-modal";
import "./equipment.css";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DatePicker } from "rsuite";
import subDays from "date-fns/subDays";
import { toast } from "react-toastify";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import PlusIcon from "../../images/icons/plus-icon.svg";
import Plus from "../../images/icons/plus-black.svg";
import React, { useState, useEffect, useRef } from "react";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { logout, reset } from "../../features/auth/authSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import TruncateFieldView from "../../components/helpers/truncateFieldView.js";
import Delete from "../../images/icons/delete.svg";
import profile_image from "../../images/user/Default_pfp.png";
import editImage from "../../images/singleinvoice/edit.svg";
import { useActiveUser, useUserById } from "../../components/TimeOff/timeOffApi.jsx";
import DownloadImage from "../../images/icons/download-icon.svg";
import { useEquipCategory, useEquipId, useFetchEquipments } from "../../features/equipments/useEquipDetails.jsx";
import EquipmentIcon from "../../images/icons/equipment-icon.svg";
import Type from "../../images/icons/type.svg";
import Name from "../../images/icons/name.svg";
import birthIcon from "../../images/icons/dat-of-birth.svg";
import UserIcon from "../../images/icons/single-user-icon.svg";
import SerialNumber from "../../images/icons/serialnumber.svg";
import Dollar from "../../images/icons/dollar-round.svg";
import Status from "../../images/icons/status.svg";
import Receipt from "../../images/icons/recipent.svg";
import Quantity from "../../images/icons/quantity.svg";
import UserImage from "../../images/user/alice.svg";
import { motion } from 'framer-motion';


const ranges = [
    {
        label: "today",
        value: new Date(), // Use a single date instead of an array
    },
    {
        label: "yesterday",
        value: subDays(new Date(), 1),
    },
];

const useRenderAssignUser = (rowData) => {
    const [showFullname, setShowFullname] = useState(false);

    const fullName = rowData.assign_user?.first_name
        ? `${rowData.assign_user.first_name} ${rowData.assign_user.middle_name && rowData.assign_user.middle_name !== "null"
            ? rowData.assign_user.middle_name + " "
            : ""
        }${rowData.assign_user.last_name}`
        : rowData.assign_user?.company_first_name
            ? `${rowData.assign_user.company_first_name} ${rowData.assign_user.company_last_name ? rowData.assign_user.company_last_name : ""
            }`
            : rowData.assign_user?.company_name;

    const displayName = showFullname
        ? fullName
        : fullName.length <= 15
            ? fullName
            : fullName.slice(0, 15) + "...";

    const componentRef2 = useRef(null);
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 }
    };

    return (

        <motion.div
            ref={componentRef2}
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            transition={{ duration: 0.3 }}
        >
            <div
                className={`member-name${showFullname ? " active" : ""}`}
                // onMouseEnter={() => setShowFullname(true)}
                onMouseEnter={() => {
                    if (fullName.length > 15) {
                        setShowFullname(true);
                    }
                }}
                onMouseLeave={() => setShowFullname(false)}
            >
                {rowData.assign_user.profile_image !== null &&
                    rowData.assign_user.profile_image !== "null" ? (
                    <img
                        src={`/uploads/lowProfileImage/${rowData.assign_user.profile_image}`}
                        alt={fullName}
                        className="member-image"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/uploads/lowProfileImage/user_default.png";
                        }}
                    />
                ) : (
                    <img src={profile_image} alt={fullName} className="member-image" />
                )}
                <span>{displayName}</span>
            </div>
        </motion.div>
    );
};

const Equipment = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [equipEditModalOpen, setEquipEditModalOpen] = useState(false);
    const [filter, setFilter] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const [equipmentIdEdit, setEquipmentIdEdit] = useState("");
    const [eqpCategory, setEqpCategory] = useState("");
    const [eqpCategoryEdit, setEqpCategoryEdit] = useState("");
    const [eqpCategoryView, setEqpCategoryView] = useState("");
    const [equipName, setEquipName] = useState("");
    const [equipNameEdit, setEquipNameEdit] = useState("");
    const [equipNameView, setEquipNameView] = useState("");
    const [purchaseDate, setPurchaseDate] = useState(null);
    const [purchaseDateEdit, setPurchaseDateEdit] = useState(null);
    const [purchaseDateView, setPurchaseDateView] = useState(null);
    const [userSearchTerm, setUserSearchTerm] = useState('');
    const [assignedUser, setAssignedUser] = useState("");
    const [assignedUserEdit, setAssignedUserEdit] = useState("");
    const [assignedUserView, setAssignedUserView] = useState("");
    const [quantity, setQuantity] = useState("");
    const [quantityEdit, setQuantityEdit] = useState("");
    const [quantityView, setQuantityView] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [serialNumberEdit, setSerialNumberEdit] = useState("");
    const [serialNumberView, setSerialNumberView] = useState("");
    const [eqpStatus, setEqpStatus] = useState("");
    const [eqpStatusEdit, setEqpStatusEdit] = useState("");
    const [eqpStatusView, setEqpStatusView] = useState("");
    const [eqpStatusDropdownOpen, setEqpStatusDropdownOpen] = useState(false);
    const [eqpStatusEditDropdownOpen, setEqpStatusEditDropdownOpen] = useState(false);
    const [eqpReceiptFiles, setEqpReceiptFiles] = useState([]);
    const [eqpReceiptFilesEdit, setEqpReceiptFilesEdit] = useState([]);
    const [removedFiles, setRemovedFiles] = useState([]);
    const [eqpReceiptFileName, setEqpReceiptFileName] = useState([]);
    const [eqpReceiptFileNameEdit, setEqpReceiptFileNameEdit] = useState([]);
    const [eqpReceiptFileNameView, setEqpReceiptFileNameView] = useState([]);
    const [eqpReceiptFileSizeView, setEqpReceiptFileSizeView] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectAllByPage, setSelectAllByPage] = useState({});
    const [isEqpDeleteModalOpen, setIsEqpDeleteModalOpen] = useState(false);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
    const [equipCategoryDropdownOpen, setEquipCategoryDropdownOpen] = useState(false);
    const [equipCategoryEditDropdownOpen, setEquipCategoryEditDropdownOpen] = useState(false);
    const [assignedUserDropdownOpen, setAssignedUserDropdownOpen] = useState(false);
    const [assignedUserEditDropdownOpen, setAssignedUserEditDropdownOpen] = useState(false);
    const [equipCategoryIsValid, setEquipCategoryIsValid] = useState(false);
    const [equipCategoryEditIsValid, setEquipCategoryEditIsValid] = useState(false);
    const [purchseDateIsValid, setPurchseDateIsValid] = useState(false);
    const [purchseDateEditIsValid, setPurchseDateEditIsValid] = useState(false);
    const [assignedUserIsValid, setAssignedUserIsValid] = useState(false);
    const [assignedUserEditIsValid, setAssignedUserEditIsValid] = useState(false);
    const [serialNumberEditIsValid, setSerialNumberEditIsValid] = useState(false);
    const [quantityEditIsValid, setQuantityEditIsValid] = useState(false);
    const [eqpStatusIsValid, setEqpStatusIsValid] = useState(false);
    const [eqpStatusEditIsValid, setEqpStatusEditIsValid] = useState(false);
    const [isEquipmentEdit, setIsEquipmentEdit] = useState(false);
    const showingDropdownRef = useRef(null);
    const equipCategoryRef = useRef(null);
    const equipCategoryEditRef = useRef(null);
    const purchaseDateRef = useRef(null);
    const purchaseDateEditRef = useRef(null);
    const assignedUserRef = useRef(null);
    const serialNumberEditRef = useRef(null);
    const quantityEditRef = useRef(null);
    const eqpStatusRef = useRef(null);
    const eqpStatusEditRef = useRef(null);
    const assignedUserEditRef = useRef(null);
    const assignedUserSelectDropdownRef = useRef(null);
    const assignedUserSelectEditDropdownRef = useRef(null);
    const eqpStatusDropdownRef = useRef(null);
    const eqpStatusEditDropdownRef = useRef(null);
    const equipCategoryDropdownRef = useRef(null);
    const equipCategoryEditDropdownRef = useRef(null);
    const eqpReceiptRef = useRef(null);
    const eqpReceiptEditRef = useRef(null);
    const { appSettings } = useSelector((state) => state.appSettings);

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
        setCurrentPage(0); // Reset page to the first page
    };

    let token = null;
    const { user } = useSelector((state) => state.auth);
    if (user) {
        if (user && user.token) {
            token = user.token;
        }
    }

    const { data: equipments = [], isLoading: isFetchingEquipment, refetch: equipmentRefetch } = useFetchEquipments(token);
    const { data: equipID = [], isLoading: isLoadingEquipId, refetch: refetchEquipmentId } = useEquipId(token);
    const { data: userIds = [], isLoading: isLoadingUser } = useUserById(token);
    const { data: activeUser = [], isLoading: isLoadingActiveUser } = useActiveUser(token);
    const { data: equipCategory = [], isLoading: isLoadingEqpCategory } = useEquipCategory(token);

    const handleClickOutsideDropdown = (event) => {
        const isClickInsideShowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);
        const isClickInsideAssignedUserDropdown = assignedUserSelectDropdownRef.current && assignedUserSelectDropdownRef.current.contains(event.target);
        const isClickInsideAssignedUserEditDropdown = assignedUserSelectEditDropdownRef.current && assignedUserSelectEditDropdownRef.current.contains(event.target);
        const isClickInsideEquipCategoryDropdown = equipCategoryDropdownRef.current && equipCategoryDropdownRef.current.contains(event.target);
        const isClickInsideEquipCategoryEditDropdown = equipCategoryEditDropdownRef.current && equipCategoryEditDropdownRef.current.contains(event.target);
        const isClickInsideEqpStatusDropdown = eqpStatusDropdownRef.current && eqpStatusDropdownRef.current.contains(event.target);
        const isClickInsideEqpStatusEditDropdown = eqpStatusEditDropdownRef.current && eqpStatusEditDropdownRef.current.contains(event.target);

        if (!isClickInsideShowingDropdown) {
            setShowingDropdownOpen(false);
        }
        if (!isClickInsideAssignedUserDropdown) {
            setAssignedUserDropdownOpen(false);
        }
        if (!isClickInsideAssignedUserEditDropdown) {
            setAssignedUserEditDropdownOpen(false);
        }
        if (!isClickInsideEquipCategoryDropdown) {
            setEquipCategoryDropdownOpen(false);
        }
        if (!isClickInsideEquipCategoryEditDropdown) {
            setEquipCategoryEditDropdownOpen(false);
        }
        if (!isClickInsideEqpStatusDropdown) {
            setEqpStatusDropdownOpen(false);
        }
        if (!isClickInsideEqpStatusEditDropdown) {
            setEqpStatusEditDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutsideDropdown);
        return () => {
            document.removeEventListener('click', handleClickOutsideDropdown);
        };
    }, []);

    useEffect(() => {
        const handleLoading = async () => {
            await dispatch(setAppLoading(isFetchingEquipment));
        };
        handleLoading();
    }, [isFetchingEquipment]);

    function detailCTA(rowData) {
        return (
            <div className="detail-button">
                <button className="cta-button"
                    onClick={() => {
                        equipmentRefetch();
                        handleDetailClick(rowData);
                    }}
                >
                    Details
                </button>
            </div>
        );
    }

    const handleDetailClick = async (rowData) => {
        setSelectedId(rowData._id);
        if (rowData.eqp_id) {
            setEquipmentIdEdit(rowData.eqp_id);
        }
        if (rowData.eqp_category) {
            setEqpCategoryEdit(rowData.eqp_category._id);
            setEqpCategoryView(rowData.eqp_category.eqp_category_name);
        }
        if (rowData.eqp_name) {
            setEquipNameEdit(rowData.eqp_name);
            setEquipNameView(rowData.eqp_name);
        }
        if (rowData.purchase_at) {
            const purchaseDate = new Date(rowData.purchase_at);
            const formattedPurchaseDate = purchaseDate.toLocaleDateString('en-US', {
                month: 'long',
                day: '2-digit',
                year: 'numeric'
            });
            setPurchaseDateEdit(new Date(rowData.purchase_at));
            setPurchaseDateView(formattedPurchaseDate);
        }
        if (rowData.assign_user) {
            setAssignedUserEdit(rowData.assign_user._id);
            setAssignedUserView(rowData.assign_user._id);
        }
        if (rowData.sl_num) {
            setSerialNumberEdit(rowData.sl_num);
            setSerialNumberView(rowData.sl_num);
        }
        if (rowData.eqp_amount) {
            setQuantityEdit(rowData.eqp_amount);
            setQuantityView(rowData.eqp_amount);
        }
        if (rowData.eqp_status) {
            setEqpStatusEdit(rowData.eqp_status);
            setEqpStatusView(rowData.eqp_status);
        }
        if (rowData.eqp_receipt) {
            setEqpReceiptFileNameEdit(rowData.eqp_receipt);
            setEqpReceiptFileNameView(rowData.eqp_receipt);
            setEqpReceiptFileSizeView(rowData.eqp_receipt_size);
            setRemovedFiles([]);
        } else {
            setEqpReceiptFilesEdit([]);
            setEqpReceiptFileNameEdit([]);
            setEqpReceiptFileNameView([]);
            setEqpReceiptFileSizeView([]);
            setRemovedFiles([]);
        }
        setEquipEditModalOpen(true);
    }

    const handleCloseDetailsModal = () => {
        setSelectedId("");
        setEquipmentIdEdit("");
        setEqpCategoryEdit("");
        setEqpCategoryView("");
        setEquipNameEdit("");
        setEquipNameView("");
        setPurchaseDateEdit(null);
        setPurchaseDateView(null);
        setSerialNumberEdit("");
        setSerialNumberView("");
        setQuantityEdit("");
        setQuantityView("");
        setEqpStatusEdit("");
        setEqpStatusView("");
        setEqpReceiptFilesEdit([]);
        setEqpReceiptFileNameEdit([]);
        setEqpReceiptFileNameView([]);
        setEqpReceiptFileSizeView([]);
        setRemovedFiles([]);
        setEquipCategoryEditIsValid(false);
        setPurchseDateEditIsValid(false);
        setAssignedUserEditIsValid(false);
        setSerialNumberEditIsValid(false);
        setQuantityEditIsValid(false);
        setEqpStatusEditIsValid(false);
        setIsEquipmentEdit(false);
        setEquipEditModalOpen(false);
    };

    const handleSetEquipmentEdit = () => {
        setIsEquipmentEdit(true);
    };

    const handleResetEquipmentEdit = () => {
        setIsEquipmentEdit(false);
    };

    const handleDateChange = (date) => {
        setPurchaseDate(date);
    };

    const handleDateEditChange = (date) => {
        setPurchaseDateEdit(date);
    };

    const disabledDate = date => {
        return date > new Date();
    };

    const handleToggleAssignedUserDropdown = () => {
        setUserSearchTerm('');
        setAssignedUserDropdownOpen((prevOpen) => !prevOpen);
    };

    const handleToggleAssignedUserEditDropdown = () => {
        setUserSearchTerm('');
        setAssignedUserEditDropdownOpen((prevOpen) => !prevOpen);
    };

    const handleSelectAssignedUser = (selectedAssignedUser) => {
        setAssignedUser(selectedAssignedUser);
        setUserSearchTerm('');
        setAssignedUserDropdownOpen(false);
    };

    const handleSelectAssignedUserEdit = (selectedAssignedUser) => {
        setAssignedUserEdit(selectedAssignedUser);
        setUserSearchTerm('');
        setAssignedUserEditDropdownOpen(false);
    };

    const handleAssignedUserSearchInputChange = (e) => {
        setUserSearchTerm(e.target.value);
    };

    const filteredUsers = activeUser.filter((user) => {
        const fullName = user.first_name
            ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
            : `${user.company_first_name ? user.company_first_name + (user.company_last_name && user.company_last_name) : user.company_name}`;
        return fullName.toLowerCase().includes(userSearchTerm.toLowerCase());
    });

    const handleEqpStatusToggleDropdown = () => {
        setEqpStatusDropdownOpen(!eqpStatusDropdownOpen);
    };

    const handleEqpStatusEditToggleDropdown = () => {
        setEqpStatusEditDropdownOpen(!eqpStatusEditDropdownOpen);
    };

    const handleEqpStatusSelectOption = (value) => {
        setEqpStatus(value);
        setEqpStatusDropdownOpen(false);
    };

    const handleEqpStatusEditSelectOption = (value) => {
        setEqpStatusEdit(value);
        setEqpStatusEditDropdownOpen(false);
    };

    const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv", "jpeg", "jpg", "png", "gif"];

    // const handleReceiptFileUpload = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const fileExtension = file.name.split(".").pop().toLowerCase();
    //         if (!allowedExtensions.includes(fileExtension)) {
    //             toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv, jpeg, jpg, png, gif.", {
    //                 position: "bottom-right",
    //                 autoClose: 2000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //             e.target.value = null;
    //             setEqpReceipt(null);
    //             setEqpReceiptFileName("");
    //             return;
    //         }
    //         setEqpReceipt(e.target.files[0])
    //         setEqpReceiptFileName(file.name)
    //     } else {
    //         setEqpReceipt(null)
    //         setEqpReceiptFileName("")
    //     }
    // };

    const handleReceiptFileUpload = (event) => {
        const selectedFiles = event.target.files;

        if (selectedFiles.length > 0) {
            if (selectedFiles.length + eqpReceiptFiles.length > 10) {
                // Display toast error message when the total number of files exceeds 10
                toast.error('Maximum of 10 files can be uploaded!', {
                    position: 'bottom-right',
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }
            const newFiles = Array.from(selectedFiles);

            // Validate file extensions and update state
            const validFiles = newFiles.filter((file) => {
                const fileExtension = file.name.split('.').pop().toLowerCase();
                if (allowedExtensions.includes(fileExtension)) {
                    return true;
                } else {
                    toast.error(`Invalid file format for ${file.name}. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!`, {
                        position: 'bottom-right',
                        autoClose: 3500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    return false;
                }
            });

            // Update the state with the valid files
            setEqpReceiptFiles((prevFiles) => [...prevFiles, ...validFiles]);

            // Clear the file input for multiple selections
            eqpReceiptRef.current.value = '';
        }
    };

    const removeFile = (index) => {
        // Remove the file at the specified index
        setEqpReceiptFiles((prevFiles) => {
            const updatedFiles = [...prevFiles];
            updatedFiles.splice(index, 1);
            return updatedFiles;
        });
    };

    // const handleReceiptFileEditUpload = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const fileExtension = file.name.split(".").pop().toLowerCase();
    //         if (!allowedExtensions.includes(fileExtension)) {
    //             toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv, jpeg, jpg, png, gif.", {
    //                 position: "bottom-right",
    //                 autoClose: 2000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //             });
    //             e.target.value = null;
    //             setEqpReceiptEdit(null);
    //             setEqpReceiptFileNameEdit("");
    //             return;
    //         }
    //         setEqpReceiptEdit(e.target.files[0]);
    //         setEqpReceiptFileNameEdit(file.name);
    //     } else {
    //         setEqpReceiptEdit(null)
    //         setEqpReceiptFileNameEdit("")
    //     }
    // };

    const handleReceiptFileEditUpload = (event) => {
        const selectedFiles = event.target.files;

        if (selectedFiles.length > 0) {
            if (selectedFiles.length + eqpReceiptFilesEdit.length > 10) {
                // Display toast error message when the total number of files exceeds 10
                toast.error('Maximum of 10 files can be uploaded!', {
                    position: 'bottom-right',
                    autoClose: 3500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }
            const newFiles = Array.from(selectedFiles);

            // Validate file extensions and update state
            const validFiles = newFiles.filter((file) => {
                const fileExtension = file.name.split('.').pop().toLowerCase();
                if (allowedExtensions.includes(fileExtension)) {
                    return true;
                } else {
                    toast.error(`Invalid file format for ${file.name}. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.!!`, {
                        position: 'bottom-right',
                        autoClose: 3500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    return false;
                }
            });

            // Update the state with the valid files
            setEqpReceiptFilesEdit((prevFiles) => [...prevFiles, ...validFiles]);

            // Clear the file input for multiple selections
            eqpReceiptEditRef.current.value = '';
        }
    };

    const removeEditFile = (index) => {
        // Remove the file at the specified index
        setEqpReceiptFilesEdit((prevFiles) => {
            const updatedFiles = [...prevFiles];
            updatedFiles.splice(index, 1);
            return updatedFiles;
        });
    };

    const handleRemoveFile = (file, index) => {
        const updatedFiles = [...eqpReceiptFileNameEdit];
        updatedFiles.splice(index, 1);
        setEqpReceiptFileNameEdit(updatedFiles);
        setRemovedFiles([...removedFiles, file]);
    };

    const downloadEqpReceiptDoc = async (eqpRecipfile) => {
        try {
            const response = await axios.get(`/api/equipment/doc/download/${eqpRecipfile}`, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const pdfBlob = new Blob([response.data], { type: "application/pdf" });
            saveAs(pdfBlob, `${eqpRecipfile}`);
        } catch (error) {
            console.error(error);
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error("This user is deleted!", {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            // Handle error
        }
    };

    function getFileExtension(filename) {
        const lastIndex = filename.lastIndexOf(".");
        if (lastIndex !== -1) {
            return filename.slice(lastIndex + 1);
        }
        return "";
    }

    const handleEqpDelete = () => {
        setIsEqpDeleteModalOpen(true);
    };

    const handleConfirmEqpDelete = async () => {
        try {
            setIsSubmitLoading(true);

            const response = await axios.get(`/api/equipment/delete/${selectedId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            toast.success("Equipment data removed successfully", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            handleCloseDetailsModal();
            global.config.activityLog(window.location.href, 'Equipment', `Equipment (${selectedId}) deleted successfully`);
            equipmentRefetch();
            // navigate(`/client/projects/${encodeURIComponent(AES.encrypt(props.id, 'encryptionKey').toString().replace(/\//g, '%2F'))}`);
        } catch (error) {
            console.error(error);
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            toast.error("Something went wrong", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } finally {
            setIsSubmitLoading(false);
            handleCancelEqpDelete();
        }
    };

    const handleCancelEqpDelete = () => {
        setSelectedId("");
        setIsEqpDeleteModalOpen(false);
    };


    const onPageChange = (e) => {
        const newPage = e.page;
        // Store the current "Select All" state for the current page
        setSelectAllByPage((prevSelectAllByPage) => ({
            ...prevSelectAllByPage,
        }));
        setCurrentPage(e.page);
    };

    const handleOpenCreateModal = () => {
        setIsCreateModalOpen(true);
    };

    const handleCloseCreateModal = () => {
        refetchEquipmentId();
        setEqpCategory("");
        setEquipName("");
        setPurchaseDate(null);
        setSerialNumber("");
        setQuantity("");
        setEqpStatus("");
        setEqpReceiptFiles([]);
        setEqpReceiptFileName("");
        setEquipCategoryIsValid(false);
        setPurchseDateIsValid(false);
        setAssignedUserIsValid(false);
        setEqpStatusIsValid(false);
        setIsEquipmentEdit(false);
        setIsCreateModalOpen(false);
    };

    const filteredData = equipments.filter((item) => {
        const searchTerm = filter.trim().toLowerCase();
        const hasMatch = item.eqp_id.toLowerCase().includes(searchTerm) ||
            item.eqp_name.toLowerCase().includes(searchTerm) ||
            item.eqp_category?.eqp_category_name.toLowerCase().includes(searchTerm);
        return hasMatch;
    });

    const totalResults = filteredData.length;


    useEffect(() => {
        dispatch(setHeaderText("Equipment"));
    }, [equipments]);


    const useRenderEqpCategory = (rowData) => {
        return (
            <span>{rowData?.eqp_category && rowData.eqp_category.eqp_category_name}</span>
        );
    }

    const convertPurchaseDate = (rowData) => {
        const timestamp = rowData.purchase_at;
        const formattedDate = moment(timestamp).format('MMMM DD, YYYY');
        return formattedDate;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        setEquipCategoryIsValid(false);
        setPurchseDateIsValid(false);
        setAssignedUserIsValid(false);
        setEqpStatusIsValid(false);
        if (
            equipID === "" ||
            equipName === "" ||
            serialNumber === "" ||
            eqpStatus === "" ||
            eqpCategory === "" ||
            purchaseDate === null ||
            assignedUser === ""
        ) {
            if (eqpCategory === "") {
                setEquipCategoryIsValid(true);
                equipCategoryRef && equipCategoryRef.current.focus();
                toast.error("Equipment category cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (purchaseDate === null) {
                setPurchseDateIsValid(true);
                purchaseDateRef && purchaseDateRef.current.focus();
                toast.error("Purchase date cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (assignedUser === "") {
                setAssignedUserIsValid(true);
                assignedUserRef && assignedUserRef.current.focus();
                toast.error("Assigned user has to be seleted!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (eqpStatus === "") {
                setEqpStatusIsValid(true);
                eqpStatusRef && eqpStatusRef.current.focus();
                toast.error("Equipment status has to be seleted!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }

            toast.error("Please fill all required fields!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }
        const requestData = {
            eqp_id: equipID,
            eqp_category: eqpCategory,
            eqp_name: equipName,
            purchase_at: purchaseDate,
            assign_user: assignedUser,
            sl_num: serialNumber,
            eqp_amount: quantity,
            eqp_status: eqpStatus,
        };

        const formData = new FormData();
        // formData.append("eqp_receipt", eqpReceipt);
        for (let i = 0; i < eqpReceiptFiles.length; i++) {
            formData.append("eqp_receipt", eqpReceiptFiles[i]);
        }
        for (let key in requestData) {
            formData.append(key, requestData[key]);
        }
        try {
            setIsSubmitLoading(true);
            const response = await axios.post("/api/equipment/create", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = response.data;
            if (data.status === "error") {
                toast.error("Something went wrong", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.success("Equipment data created successfully", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                handleCloseCreateModal();
                equipmentRefetch();
                global.config.activityLog(window.location.href, 'Equipment', `Equipment, (${equipName}) data created Successfully`);
            }
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            alert("Something went wrong");
        } finally {
            setIsSubmitLoading(false);
        }
    };

    const handleEqpEditSubmit = async (event) => {
        event.preventDefault();
        setEquipCategoryEditIsValid(false);
        setPurchseDateEditIsValid(false);
        setAssignedUserEditIsValid(false);
        setSerialNumberEditIsValid(false);
        setQuantityEditIsValid(false);
        setEqpStatusEditIsValid(false);
        if (
            equipNameEdit === "" ||
            serialNumberEdit === "" ||
            quantityEdit === "" ||
            eqpStatusEdit === "" ||
            eqpCategoryEdit === "" ||
            purchaseDateEdit === null ||
            assignedUserEdit === ""
        ) {
            if (eqpCategoryEdit === "") {
                setEquipCategoryEditIsValid(true);
                equipCategoryEditRef && equipCategoryEditRef.current.focus();
                toast.error("Equipment category cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (purchaseDateEdit === null) {
                setPurchseDateEditIsValid(true);
                purchaseDateEditRef && purchaseDateEditRef.current.focus();
                toast.error("Purchase date cannot be empty!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (assignedUserEdit === "") {
                setAssignedUserEditIsValid(true);
                assignedUserEditRef && assignedUserEditRef.current.focus();
                toast.error("Assigned user has to be seleted!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (serialNumberEdit === "") {
                setSerialNumberEditIsValid(true);
                serialNumberEditRef && serialNumberEditRef.current.focus();
                toast.error("Serial number cannot be empty!!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (quantityEdit === "") {
                setQuantityEditIsValid(true);
                quantityEditRef && quantityEditRef.current.focus();
                toast.error("Quantity field cannot be empty!!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            } else if (eqpStatusEdit === "") {
                setEqpStatusEditIsValid(true);
                eqpStatusEditRef && eqpStatusEditRef.current.focus();
                toast.error("Equipment status has to be seleted!", {
                    position: "bottom-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }

            toast.error("Please fill all required fields!", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }
        const requestData = {
            eqp_category: eqpCategoryEdit,
            eqp_name: equipNameEdit,
            purchase_at: purchaseDateEdit,
            assign_user: assignedUserEdit,
            sl_num: serialNumberEdit,
            eqp_amount: quantityEdit,
            eqp_status: eqpStatusEdit,
        };

        const formData = new FormData();
        // if (eqpReceiptEdit) {
        //     formData.append("eqp_receipt", eqpReceiptEdit);
        // }
        if (removedFiles.length > 0) {
            requestData.removed_files = JSON.stringify(removedFiles);
        }
        if (eqpReceiptFilesEdit) {
            for (let i = 0; i < eqpReceiptFilesEdit.length; i++) {
                formData.append("eqp_receipt", eqpReceiptFilesEdit[i]);
            }
        }
        for (let key in requestData) {
            formData.append(key, requestData[key]);
        }
        try {
            setIsSubmitLoading(true);
            await axios.put(`/api/equipment/update/${selectedId}`, formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })

            toast.success("Equipments updated successfully", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            equipmentRefetch();
            handleCloseDetailsModal();
            global.config.activityLog(window.location.href, 'Equipment', `Equipment data of (${equipNameEdit}) updated successfully`);
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
            if (error.response?.data?.status === "deleted") {
                localStorage.removeItem("user");
                dispatch(logout());
                dispatch(reset());
                dispatch(invoiceReset());
                dispatch(headerReset());
                dispatch(appSettingsReset());
                toast.error('This user is deleted!', {
                    position: "bottom-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                navigate("/");
                return;
            }
            alert("Something went wrong");
        } finally {
            equipmentRefetch();
            setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
        }
    };

    const exportToExcel = () => {
        if (filteredData.length === 0) {
            toast.error("No data to export.", {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return;
        }
        try {
            const now = new Date();
            const formattedDate =
                now.getFullYear() +
                "-" +
                (now.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                now.getDate().toString().padStart(2, "0");
            const formattedTime =
                now.getHours().toString().padStart(2, "0") +
                ":" +
                now.getMinutes().toString().padStart(2, "0") +
                ":" +
                now.getSeconds().toString().padStart(2, "0");

            const modifiedLog = filteredData.map((item, index) => ({
                "Sl No": index + 1,
                "Equipment ID": item.eqp_id,
                "Category": item.eqp_category
                    ? item.eqp_category.eqp_category_name
                    : '',
                "Name": item.eqp_name,
                "Purchase Date": moment(item.purchase_at)
                    .tz(global.config.getTimeZone())
                    .format("DD/MM/YYYY"),
                "Assigned User": item.assign_user
                    ? item.assign_user.first_name
                        ? `${item.assign_user.first_name} ${item.assign_user.middle_name ? item.assign_user.middle_name : ''} ${item.assign_user.last_name ? item.assign_user.last_name : ''}`
                        : item.assign_user.company_first_name
                            ? `${item.assign_user.company_first_name} ${item.assign_user.company_last_name ? item.assign_user.company_last_name : ''}`
                            : item.assign_user.company_name
                    : '',
                "Created At": moment(item.created_at).tz(global.config.getTimeZone()).format("DD/MM/YYYY, hh:mm:ss A"),
            }));

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
            const colWidths = [
                { wpx: 25 },
                { wpx: 75 },
                { wpx: 110 },
                { wpx: 175 },
                { wpx: 120 },
                { wpx: 175 },
                { wpx: 150 },
            ];
            worksheet["!cols"] = colWidths;
            // Add alignment to center align the first row and increase font size
            const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
            for (let i = 0; i < colWidths.length; i++) {
                const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
                const style = worksheet[cell]?.s || {};
                style.alignment = style.alignment || {};
                style.alignment.horizontal = "center !important";
                style.alignment.vertical = "center !important";
                style.font = { size: 14, bold: true };
                worksheet[cell] = { ...worksheet[cell], s: style };
            }
            // Set border for active area and increase font size
            const range = XLSX.utils.decode_range(worksheet["!ref"]);
            for (let row = range.s.r + 1; row <= range.e.r; row++) {
                for (let col = range.s.c; col <= range.e.c; col++) {
                    const cell = XLSX.utils.encode_cell({ r: row, c: col });
                    const style = worksheet[cell]?.s || {};
                    style.font = { size: 12 };
                    worksheet[cell] = { ...worksheet[cell], s: style };
                }
            }
            global.config.activityLog(
                window.location.href,
                "Equipments",
                "Equipments exported to Excel"
            );
            const fileName = `Equipments_${formattedDate}_${formattedTime}.xlsx`;
            worksheet["!autofilter"] = { ref: range };
            XLSX.utils.book_append_sheet(workbook, worksheet, "Equipments");
            XLSX.writeFile(workbook, fileName);
        } catch (error) {
            console.log(error);
            global.config.slackMessage(error.toString());
            global.config.activityLog(
                window.location.href,
                "Equipments",
                "Error occurred while exporting Equipments datas to Excel"
            );
            alert("Error occurred while exporting Equipments datas to Excel.");
        }
    };

    const handleEquipmentCategory = (event) => {
        navigate("/user/equipment/equipment/category");
    };

    const numberInputOnWheelPreventChange = (e) => {
        // Prevent the input value change
        e.target.blur()

        // Prevent the page/container scrolling
        e.stopPropagation()

        setTimeout(() => {
            e.target.focus()
        }, 0)
    }

    const componentRef = useRef(null);
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 }
    };

    return (
        <motion.div
            ref={componentRef}
            initial="hidden"
            animate="visible"
            variants={fadeIn}
            transition={{ duration: 0.3 }}
        >
            <div className="client-document-outer">
                <div className="manage">
                    <a onClick={handleEquipmentCategory}>
                        <span className="icon-invoice">
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_1143_332)">
                                    <path d="M19.0704 7.87245C18.7124 7.87245 18.3983 7.6613 18.2626 7.33065L18.2304 7.25449C18.0947 6.92941 18.1709 6.55604 18.4255 6.30093C19.1789 5.54799 19.1733 4.32322 18.4255 3.57585L17.4281 2.57895C16.702 1.85263 15.4444 1.84768 14.7121 2.5678L14.7009 2.57895C14.4463 2.82786 14.0721 2.90402 13.7525 2.76842L13.6763 2.73622C13.3454 2.60619 13.1342 2.28607 13.1342 1.92879C13.1342 0.866873 12.2668 0 11.2044 0H9.78936C8.72688 0 7.85954 0.866873 7.85954 1.92879C7.85954 2.28669 7.64828 2.60619 7.32303 2.73622L7.25241 2.76842C6.92716 2.90402 6.55359 2.83344 6.29834 2.57895C5.545 1.83158 4.32516 1.83158 3.57182 2.57895L2.57438 3.57585C1.82104 4.32879 1.82104 5.54799 2.57438 6.3065C2.82901 6.56099 2.89963 6.92941 2.76396 7.26006L2.7367 7.33065C2.6066 7.6613 2.28631 7.87245 1.92884 7.87245C0.866357 7.87245 -0.000976562 8.73932 -0.000976562 9.80124V11.2099C-0.000976562 12.2774 0.866357 13.1387 1.91831 13.1387C2.27639 13.1387 2.59049 13.3498 2.72617 13.6749L2.75838 13.7511C2.89406 14.0762 2.81786 14.4495 2.56323 14.7046C1.81485 15.4576 1.81485 16.6824 2.56881 17.4297L3.57182 18.4266C4.32516 19.1746 5.545 19.1746 6.29834 18.4211C6.54739 18.1721 6.92158 18.096 7.24683 18.2316L7.31746 18.2638C7.64828 18.3938 7.85954 18.7139 7.85954 19.0712C7.85954 20.1331 8.72688 21 9.78936 21H11.2044C12.2668 21 13.1342 20.1387 13.1391 19.0656C13.1391 18.7077 13.3504 18.3938 13.6812 18.2582C13.6868 18.2582 13.7518 18.231 13.7518 18.231C14.0771 18.0954 14.4513 18.1715 14.7003 18.4204L14.7115 18.4316C15.4376 19.1523 16.7008 19.1467 17.4275 18.4204L18.4249 17.4235C19.1782 16.6762 19.1782 15.457 18.4249 14.6985C18.1759 14.4495 18.0996 14.0755 18.2353 13.7505L18.2626 13.6799C18.3983 13.3492 18.713 13.1381 19.0704 13.1381C20.1329 13.1381 21.0003 12.2712 21.0003 11.2093V9.80062C21.0003 8.7387 20.1329 7.87183 19.0704 7.87183V7.87245ZM19.965 11.2037C19.965 11.6861 19.5692 12.0817 19.0866 12.0817C18.2948 12.0817 17.596 12.5529 17.3029 13.2793L17.2757 13.3443C16.9721 14.065 17.1351 14.8885 17.6932 15.4464C18.0346 15.7932 18.0346 16.3461 17.6932 16.6873L16.6958 17.6842C16.3538 18.0254 15.7956 18.0254 15.4543 17.6842L15.4431 17.6731C14.8905 17.1257 14.0666 16.9684 13.351 17.2669L13.5517 17.7492L13.286 17.2885C12.5599 17.5814 12.0878 18.2805 12.0878 19.0712C12.0878 19.5536 11.6919 19.9492 11.2093 19.9492H9.79431C9.31171 19.9492 8.91583 19.5591 8.91583 19.0712C8.91583 18.2854 8.44995 17.587 7.72325 17.2941L7.6582 17.2669C7.41968 17.1641 7.16506 17.1152 6.91539 17.1152C6.41667 17.1152 5.92911 17.3158 5.57102 17.6842C5.22904 18.0254 4.67085 18.0254 4.32949 17.6842L3.33206 16.6873C2.99008 16.3461 2.99008 15.7882 3.33764 15.4415C3.89025 14.8892 4.05319 14.065 3.74962 13.3449L3.72236 13.2799C3.42437 12.5591 2.72493 12.0879 1.93875 12.0879C1.45614 12.0879 1.06027 11.6923 1.06027 11.2099V9.80124C1.06027 9.31889 1.45057 8.92322 1.93875 8.92322C2.72493 8.92322 3.42437 8.45201 3.72236 7.7257L3.74962 7.66625C4.05319 6.94551 3.89025 6.12198 3.33206 5.56409C2.9907 5.21734 2.9907 4.6644 3.33206 4.32322L4.32949 3.32632C4.67147 2.98514 5.22966 2.98514 5.57102 3.32632C6.12426 3.88421 6.9476 4.04706 7.6743 3.74365L7.73378 3.72198C8.4549 3.42415 8.92636 2.72508 8.92636 1.93932C8.92636 1.45697 9.32224 1.0613 9.80485 1.0613H11.2198C11.7024 1.0613 12.0983 1.45139 12.0983 1.93932C12.0983 2.72508 12.5642 3.42353 13.2909 3.71641L13.5077 3.23406L13.356 3.73808C14.0771 4.03591 14.8955 3.87864 15.4481 3.33189L15.4592 3.32074C15.8012 2.97957 16.3594 2.97957 16.7008 3.32074L17.6982 4.31765C18.0402 4.65944 18.0402 5.21176 17.6926 5.55851C17.1394 6.11641 16.9771 6.93498 17.2751 7.65511L17.3023 7.72012C17.6003 8.44582 18.2998 8.91765 19.0859 8.91765C19.5685 8.91765 19.9644 9.31331 19.9644 9.79567V11.2043L19.965 11.2037Z" fill="#6A7988" />
                                    <path d="M10.4949 5.60248C7.79011 5.60248 5.58398 7.80743 5.58398 10.5108C5.58398 13.2142 7.78453 15.4192 10.4949 15.4192C13.2054 15.4192 15.4065 13.2142 15.4059 10.5108C15.4059 7.80743 13.1998 5.60248 10.4949 5.60248ZM10.4949 14.3635C8.36998 14.3635 6.63532 12.6297 6.63532 10.5059C6.63532 8.38204 8.36441 6.6483 10.4949 6.6483C12.6255 6.6483 14.3546 8.38204 14.3546 10.5059C14.3546 12.6297 12.6199 14.3635 10.4949 14.3635Z" fill="#6A7988" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_1143_332">
                                        <rect width="21" height="21" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                        Manage Categories
                    </a>
                </div>
                <div className="user-outer-timeoff document-client-top-sec equipment-table"  >
                    <div className="invoice-top">
                        <div className="button-sec-invoice">
                            <a className="btn-forpop-initem"
                                onClick={handleOpenCreateModal}
                            >
                                <span className="icon-invoice">
                                    <img src={PlusIcon} alt="Add new Equipment " />
                                </span>
                                Add new
                            </a>

                            <Modal
                                className="client-modal project-modal"
                                isOpen={isCreateModalOpen}
                                onRequestClose={!isSubmitLoading ? handleCloseCreateModal : undefined}
                                contentLabel="Create Equipment Data"
                                style={{
                                    content: {
                                        height: "41%",
                                        width: "30%",
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-40%, -50%)",
                                        parent: document.querySelector(".admin-outer.time.tracker"),
                                    },
                                }}
                            >
                                <div className="modal timeoff-modal">
                                    <div className="modal-close-invite outter-modal-main">
                                        <a className="" onClick={handleCloseCreateModal} disabled={isSubmitLoading}>
                                            <img src={crssrImage} alt="Edit Icon" />{" "}
                                        </a>
                                    </div>
                                    <div className="modal-client-head">
                                        <h2 className="">Create Equipment Details</h2>
                                    </div>
                                    <div className="form-field-client-outer profile-details-edit">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-field-client">
                                                <label htmlFor="EquipID" className="form-label">
                                                    Equipment ID
                                                </label>
                                                {isLoadingEquipId == true ? (
                                                    <div className="outter-load-table">
                                                        <ThreeDots
                                                            height="18"
                                                            width="20"
                                                            radius="9"
                                                            color="#405BFF"
                                                            ariaLabel="three-dots-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClassName=""
                                                            visible={true}
                                                        />
                                                    </div>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        id="EquipID"
                                                        name="EquipID"
                                                        className="form-input readonly"
                                                        value={equipID}
                                                        // onChange={(e) => setClientName(e.target.value)}
                                                        required
                                                        ref={equipCategoryRef}
                                                        readOnly
                                                    />
                                                )}
                                            </div>
                                            <div className="form-field-client">
                                                <label htmlFor="client" className="form-label">
                                                    Category
                                                </label>

                                                {isLoadingEqpCategory == true ? (
                                                    <div className="outter-load-table">
                                                        <ThreeDots
                                                            height="18"
                                                            width="20"
                                                            radius="9"
                                                            color="#405BFF"
                                                            ariaLabel="three-dots-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClassName=""
                                                            visible={true}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div
                                                        ref={equipCategoryDropdownRef}
                                                        className={`cursor ${equipCategoryDropdownOpen ? 'open' : ''}`}
                                                    >
                                                        <span
                                                            id="user-select"
                                                            onClick={() => setEquipCategoryDropdownOpen(!equipCategoryDropdownOpen)}
                                                            className={`custom-dropdown-user-new custom-dropdown-select user-equipment ${equipCategoryIsValid ? 'input-validation-error' : ''}`}
                                                            ref={equipCategoryRef}
                                                        >
                                                            {eqpCategory ? equipCategory.find((eqp) => eqp._id === eqpCategory)?.eqp_category_name : 'Select'}
                                                        </span>
                                                        {equipCategoryDropdownOpen && (
                                                            <div className="custom-dropdown-new">
                                                                <ul className="leave-type-list">
                                                                    {equipCategory &&
                                                                        equipCategory
                                                                            .slice()
                                                                            .sort((a, b) => a.eqp_category_name.toLowerCase().localeCompare(b.eqp_category_name.toLowerCase()))
                                                                            .map((eqp) => (
                                                                                <li
                                                                                    key={eqp._id}
                                                                                    className={eqpCategory === eqp._id ? 'selected-item' : ''}
                                                                                    onClick={() => {
                                                                                        setEqpCategory(eqp._id);
                                                                                        setEquipCategoryDropdownOpen(false);
                                                                                    }}
                                                                                >
                                                                                    {eqp.eqp_category_name}
                                                                                </li>
                                                                            ))}
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {equipCategoryIsValid && (
                                                    <span className="text-red-500 text-xs italic">
                                                        Equipment Category Field Cannot be empty
                                                    </span>
                                                )}
                                            </div>
                                            <div className="form-field-client">
                                                <label htmlFor="clientName" className="form-label">
                                                    Name
                                                </label>
                                                <input
                                                    type="text"
                                                    id="equipName"
                                                    name="equipName"
                                                    className="form-input"
                                                    value={equipName}
                                                    onChange={(e) => setEquipName(e.target.value)}
                                                    required
                                                />
                                            </div>

                                            <div className="form-field-client" >
                                                <label htmlFor="projectName" className="form-label">
                                                    Purchase Date
                                                </label>
                                                <div className="date-picker-outer date-picker-outer-all">
                                                    <div className="custoom-icon-calender custoom-icon-calender-all" ref={purchaseDateRef}>
                                                        <DatePicker
                                                            oneTap
                                                            format="dd/MM/yyyy"
                                                            ranges={ranges}
                                                            value={purchaseDate}
                                                            onChange={handleDateChange}
                                                            placement="auto"
                                                            className="invoice-filter-top-date"
                                                            isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === 'Monday'}
                                                            timeZone={global.config.getTimeZone()}
                                                            disabledDate={disabledDate}
                                                        />
                                                    </div>
                                                    <div className="custom-picker-icon custom-picker-icon-all">
                                                        <svg
                                                            width="1em"
                                                            height="1em"
                                                            viewBox="0 0 14 14"
                                                            fill="currentColor"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            class="rs-picker-toggle-caret rs-icon"
                                                            aria-label="calendar"
                                                            data-category="legacy"
                                                        >
                                                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                                                        </svg>
                                                    </div>
                                                </div>

                                                {purchseDateIsValid && (
                                                    <span className="text-red-500 text-xs italic">
                                                        Select the Purchase date
                                                    </span>
                                                )}
                                            </div>
                                            <div className="form-field-client">
                                                <label htmlFor="client" className="form-label">
                                                    Assigned User
                                                </label>
                                                {(isLoadingUser == true || isLoadingActiveUser) ? (
                                                    <div className="outter-load-table">
                                                        <ThreeDots
                                                            height="18"
                                                            width="20"
                                                            radius="9"
                                                            color="#405BFF"
                                                            ariaLabel="three-dots-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClassName=""
                                                            visible={true}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div ref={assignedUserSelectDropdownRef} className={`cursor ${assignedUserDropdownOpen ? 'open' : ''}`} >
                                                        <span
                                                            id="user-select"
                                                            onClick={handleToggleAssignedUserDropdown}
                                                            className={`custom-dropdown-user-new custom-dropdown-user user-equipment ${assignedUserIsValid ? 'input-validation-error' : ''}`}
                                                            ref={assignedUserRef}
                                                        >
                                                            {assignedUser ? (
                                                                activeUser?.find((user) => user._id === assignedUser)?.first_name ? (
                                                                    <>
                                                                        {activeUser?.find((user) => user._id === assignedUser)?.first_name}{' '}
                                                                        {activeUser?.find((user) => user._id === assignedUser)?.middle_name &&
                                                                            activeUser?.find((user) => user._id === assignedUser)?.middle_name !== 'null'
                                                                            ? activeUser?.find((user) => user._id === assignedUser)?.middle_name + ' '
                                                                            : ''}
                                                                        {activeUser?.find((user) => user._id === assignedUser)?.last_name}{' '}
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        {activeUser.find((user) => user._id === assignedUser)?.company_first_name
                                                                            ? `${activeUser.find((user) => user._id === assignedUser)?.company_first_name} ${activeUser.find((user) => user._id === assignedUser)?.company_last_name
                                                                                ? activeUser.find((user) => user._id === assignedUser)?.company_last_name
                                                                                : ''
                                                                            }`
                                                                            : `${activeUser.find((user) => user._id === assignedUser)?.company_name || ''}(Company)`}
                                                                    </>
                                                                )
                                                            ) : (
                                                                'Select Assigned User'
                                                            )}
                                                        </span>
                                                        {assignedUserDropdownOpen && (
                                                            <div className="custom-dropdown-new">
                                                                <input
                                                                    type="text"
                                                                    className="search-bar"
                                                                    placeholder="Search..."
                                                                    value={userSearchTerm}
                                                                    onChange={handleAssignedUserSearchInputChange}
                                                                />
                                                                <ul className="client-list">
                                                                    {filteredUsers.length > 0 &&
                                                                        filteredUsers
                                                                            .slice()
                                                                            .sort((a, b) => {
                                                                                const nameA = a.first_name
                                                                                    ? `${a.first_name} ${a.middle_name || ''} ${a.last_name}`
                                                                                    : `${a.company_first_name ? a.company_first_name + (a.company_last_name && a.company_last_name) : a.company_name}`;
                                                                                const nameB = b.first_name
                                                                                    ? `${b.first_name} ${b.middle_name || ''} ${b.last_name}`
                                                                                    : `${b.company_first_name ? b.company_first_name + (b.company_last_name && b.company_last_name) : b.company_name}`;
                                                                                return nameA.localeCompare(nameB);
                                                                            })
                                                                            .map((item) => (
                                                                                <li key={item._id} className={assignedUser === item._id ? 'selected-item' : ''} onClick={() => handleSelectAssignedUser(item._id)}>
                                                                                    {item.first_name ? (
                                                                                        <>
                                                                                            {item.first_name}{' '}
                                                                                            {item.middle_name && item.middle_name !== 'null' ? item.middle_name + ' ' : ''}
                                                                                            {item.last_name}{' '}
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            {item.company_first_name
                                                                                                ? `${item.company_first_name} ${item.company_last_name ? item.company_last_name : ''}`
                                                                                                : `${item.company_name || ''}(Company)`}
                                                                                        </>
                                                                                    )}
                                                                                </li>
                                                                            ))
                                                                    }
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {assignedUserIsValid && (
                                                    <span className="text-red-500 text-xs italic">
                                                        Assigned User needs to be selected
                                                    </span>
                                                )}
                                            </div>

                                            <div className="form-field-client">
                                                <label htmlFor="serialNumber" className="form-label">
                                                    Serial Number
                                                </label>
                                                <input
                                                    type="text"
                                                    id="serialNumber"
                                                    name="serialNumber"
                                                    className="form-input"
                                                    value={serialNumber}
                                                    onChange={(e) => setSerialNumber(e.target.value)}
                                                    required
                                                />
                                            </div>
                                            <div className="form-field-client">
                                                <label htmlFor="quantity" className="form-label">
                                                    Quantity
                                                </label>
                                                <input
                                                    type="number"
                                                    id="quantity"
                                                    name="quantity"
                                                    className="form-input"
                                                    value={quantity}
                                                    onChange={(e) => setQuantity(e.target.value)}
                                                    required
                                                    onWheel={numberInputOnWheelPreventChange}
                                                />
                                            </div>
                                            <div className="form-field-client">
                                                <label htmlFor="eqpStatus" className="form-label">
                                                    Status
                                                </label>
                                                <div className="custom-dropdown" ref={eqpStatusRef}>
                                                    <div ref={eqpStatusDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${eqpStatusDropdownOpen ? 'open' : ''} ${eqpStatusIsValid ? 'input-validation-error' : ''}`}>
                                                        <div className="selected-option custom-dropdown-user-new" onClick={handleEqpStatusToggleDropdown}>
                                                            {eqpStatus ? eqpStatus : 'Select Type'}
                                                        </div>
                                                        {eqpStatusDropdownOpen && (
                                                            <div className="custom-dropdown-new">
                                                                <ul className="type-list">
                                                                    <li className={eqpStatus === 'In Progress' ? 'selected-item' : ''} onClick={() => handleEqpStatusSelectOption('Purchased')}>Purchased</li>
                                                                    <li className={eqpStatus === 'Cancelled' ? 'selected-item' : ''} onClick={() => handleEqpStatusSelectOption('Appointed')}>Appointed</li>
                                                                    <li className={eqpStatus === 'Delivered' ? 'selected-item' : ''} onClick={() => handleEqpStatusSelectOption('Returned')}>Returned</li>
                                                                    <li className={eqpStatus === 'Delivered' ? 'selected-item' : ''} onClick={() => handleEqpStatusSelectOption('Depreciated')}>Depreciated</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <span className="custom-arrow"></span>
                                                </div>
                                                {eqpStatusIsValid && (
                                                    <span className="text-red-500 text-xs italic">
                                                        Equipment status needs to be selected
                                                    </span>
                                                )}
                                            </div>

                                            <div className="form-field-client equipment-multi-upload">
                                                <label htmlFor="companyLogo" className="form-label">
                                                    Receipt
                                                </label>
                                                <div className={`file-input-wrapper equipment-doc-download equipment-doc-download-create ${eqpReceiptFiles.length > 0 ? 'equipment-doc-download-create-active' : ''}`}>
                                                    {eqpReceiptFiles.length > 0 ? (
                                                        <div className="upload-file-name-br">
                                                            {eqpReceiptFiles.map((file, index) => (
                                                                <div key={index} className="uploaded-file-item">
                                                                    <div className="the-src-pdf-file equipment-doc-download">
                                                                        <div className="bottom-download-outer">
                                                                            <div className="bottom-download-inner">
                                                                                <div className="bottom-download-item">
                                                                                    <div className="attachment-file-sib-pname">
                                                                                        <span className="shortened-name" title={file.name}>{file.name}</span>
                                                                                    </div>
                                                                                    <div className="attachment-file-sib-psize">{file.name && file.name.split('.').pop()?.toUpperCase()}{"     "} <span>127.2 KB</span></div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="bottom-download-inner-right" onClick={() => removeFile(index)}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                                                    <path d="M16.9576 19.6445L17.4362 4.37763H19.577V3.85209H14.0107V2.45942C14.0107 1.69739 13.4314 1.09302 12.701 1.09302H7.96587C7.23545 1.09302 6.65615 1.69739 6.65615 2.45942V3.85209H1.08984V4.37763H3.23073L3.70928 19.6445C3.73447 20.354 4.28858 20.9058 4.96863 20.9058H15.6731C16.3783 20.9058 16.9324 20.354 16.9576 19.6445ZM7.15989 2.45942C7.15989 1.98643 7.51251 1.61856 7.96587 1.61856H12.701C13.1544 1.61856 13.507 1.98643 13.507 2.45942V3.85209H7.15989V2.45942ZM4.21302 19.6182L3.73447 4.37763H16.9324L16.4539 19.6182C16.4287 20.0387 16.1012 20.3803 15.6983 20.3803H4.96863C4.56564 20.3803 4.23821 20.0387 4.21302 19.6182Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M15.6736 21H4.96874C4.23877 21 3.64643 20.4064 3.61944 19.6486L3.14359 4.4723H1V3.75907H6.56631V2.46024C6.56631 1.64144 7.18114 1 7.96598 1H12.7011C13.486 1 14.1008 1.64144 14.1008 2.46024V3.75907H19.6671V4.4723H17.5231L17.0504 19.5515H17.0508L17.0472 19.6486C17.0202 20.4064 16.4166 21 15.6732 21H15.6736ZM1.17991 4.28414H3.3181L3.79935 19.6416C3.82273 20.2976 4.33637 20.8118 4.96874 20.8118H15.6736C16.3267 20.8118 16.8376 20.3149 16.8673 19.6538V19.6416L17.349 4.28414H19.4872V3.9463H13.9209V2.45978C13.9209 1.74608 13.3852 1.18722 12.7011 1.18722H7.96598C7.28189 1.18722 6.74622 1.74608 6.74622 2.45978V3.9463H1.17991V4.28414ZM4.96874 20.4745C4.52347 20.4745 4.15196 20.101 4.12363 19.6242V19.6214L3.64193 4.28367H17.0256L16.5439 19.6214C16.5151 20.101 16.1441 20.474 15.6984 20.474H4.96874V20.4745ZM4.30308 19.6139C4.32647 19.9912 4.61837 20.2868 4.96874 20.2868H15.6984C16.0492 20.2868 16.3415 19.9907 16.364 19.6125L16.8394 4.47137H3.82723L4.30263 19.6134L4.30308 19.6139ZM13.5971 3.9463H7.07005V2.45978C7.07005 1.93565 7.46359 1.52507 7.96598 1.52507H12.7011C13.2035 1.52507 13.5971 1.93565 13.5971 2.45978V3.9463ZM7.24995 3.7586H13.4172V2.45978C13.4172 2.04075 13.1028 1.71276 12.7011 1.71276H7.96598C7.56434 1.71276 7.24995 2.04075 7.24995 2.45978V3.7586Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M10.0811 8.37158H10.5848V16.2284H10.0811V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M10.6749 16.3223H9.99121V8.27783H10.6749V16.3223ZM10.1711 16.1346H10.4949V8.46552H10.1711V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M7.05859 8.37158H7.56233V16.2284H7.05859V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M7.65239 16.3223H6.96875V8.27783H7.65239V16.3223ZM7.14866 16.1346H7.47249V8.46552H7.14866V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M13.1045 8.37158H13.6082V16.2284H13.1045V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    <path d="M13.6983 16.3223H13.0146V8.27783H13.6983V16.3223ZM13.1946 16.1346H13.5184V8.46552H13.1946V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="form-input form-input-file"
                                                            value={eqpReceiptFileName}
                                                            // ref={expenseClientRef}
                                                            readOnly
                                                        />
                                                    )}
                                                    <input
                                                        ref={eqpReceiptRef}
                                                        type="file"
                                                        id="receiptFile"
                                                        name="receiptFile"
                                                        style={{ display: 'none' }}
                                                        className="form-input hidden-input"
                                                        onChange={handleReceiptFileUpload}
                                                        multiple
                                                    />
                                                    <label
                                                        htmlFor="receiptFile"
                                                        className="file-input-label"
                                                    >
                                                        <img src={Plus} alt="Browse" />Browse
                                                    </label>
                                                </div>
                                            </div>
                                            <button type="submit" className="submit-client" disabled={isSubmitLoading}>
                                                {isSubmitLoading ?
                                                    <div className="outter-load-table">
                                                        <ThreeDots
                                                            height="18"
                                                            width="20"
                                                            radius="9"
                                                            color="white"
                                                            ariaLabel="three-dots-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClassName=""
                                                            visible={true}
                                                        />
                                                    </div> : 'Create Equipment'}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </Modal>

                          
                                <a  onClick={exportToExcel}>
                                    <span className="icon-invoice">
                                        <img src={DownloadImage} alt="Export" />
                                    </span>
                                    Export Data
                                </a>
                            
                        </div>

                        <Modal
                            className="client-modal project-modal equipment-modal"
                            isOpen={equipEditModalOpen}
                            onRequestClose={handleCloseDetailsModal}
                            contentLabel="View and Edit Equipment"
                            style={{
                                content: {
                                    height: "41%",
                                    width: "30%",
                                    position: "fixed",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    parent: document.querySelector(".admin-outer.time.tracker"),
                                },
                            }}
                        >
                            <div className="modal timeoff-review">
                                <div className="modal-close-invite outter-modal-main">
                                    <a className="" onClick={handleCloseDetailsModal}>
                                        <img src={crssrImage} alt="Edit Icon" />{" "}
                                    </a>
                                </div>
                                <div className="project-detail-modal">
                                    <div className="modal-client-head ">
                                        {isEquipmentEdit ? (
                                            <h2 className="">Edit Equipment Details</h2>
                                        ) : (
                                            <h2 className="">Equipment Details</h2>
                                        )}
                                    </div>
                                    <div className={`form-field-client-outer ${isEquipmentEdit ? 'equipment-section-modal-edit' : 'equipment-section-modal'}`}>
                                        <form>
                                            <div className="form-field-client">
                                                {isEquipmentEdit || equipmentIdEdit ? (
                                                    <label htmlFor="equipmentId" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={EquipmentIcon} alt="usericon" />
                                                        </div>
                                                        Equipment ID
                                                    </label>
                                                ) : null}
                                                {equipmentIdEdit && (
                                                    <p className="form-input">{equipmentIdEdit}</p>
                                                )}
                                            </div>
                                            <div className="form-field-client">
                                                {isEquipmentEdit || eqpCategoryView ? (
                                                    <label htmlFor="category" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={Type} alt="usericon" />
                                                        </div>
                                                        Category
                                                    </label>
                                                ) : null}
                                                {isEquipmentEdit ? (
                                                    <>
                                                        {isLoadingEqpCategory == true ? (
                                                            <div className="outter-load-table">
                                                                <ThreeDots
                                                                    height="18"
                                                                    width="20"
                                                                    radius="9"
                                                                    color="#405BFF"
                                                                    ariaLabel="three-dots-loading"
                                                                    wrapperStyle={{}}
                                                                    wrapperClassName=""
                                                                    visible={true}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                ref={equipCategoryEditDropdownRef}
                                                                className={`cursor ${equipCategoryEditDropdownOpen ? 'open' : ''}`}
                                                            >
                                                                <span
                                                                    id="user-select"
                                                                    onClick={() => setEquipCategoryEditDropdownOpen(!equipCategoryEditDropdownOpen)}
                                                                    className={`custom-dropdown-user-new custom-dropdown-select user-equipment ${equipCategoryEditIsValid ? 'input-validation-error' : ''}`}
                                                                    ref={equipCategoryEditRef}
                                                                >
                                                                    {eqpCategoryEdit ? equipCategory.find((eqp) => eqp._id === eqpCategoryEdit)?.eqp_category_name : 'Select'}
                                                                </span>
                                                                {equipCategoryEditDropdownOpen && (
                                                                    <div className="custom-dropdown-new">
                                                                        <ul className="leave-type-list">
                                                                            {equipCategory &&
                                                                                equipCategory
                                                                                    .slice()
                                                                                    .sort((a, b) => a.eqp_category_name.toLowerCase().localeCompare(b.eqp_category_name.toLowerCase()))
                                                                                    .map((eqp) => (
                                                                                        <li
                                                                                            key={eqp._id}
                                                                                            className={eqpCategoryEdit === eqp._id ? 'selected-item' : ''}
                                                                                            onClick={() => {
                                                                                                setEqpCategoryEdit(eqp._id);
                                                                                                setEquipCategoryEditDropdownOpen(false);
                                                                                            }}
                                                                                        >
                                                                                            {eqp.eqp_category_name}
                                                                                        </li>
                                                                                    ))}
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                        {equipCategoryEditIsValid && (
                                                            <span className="text-red-500 text-xs italic">
                                                                Equipment Category Field Cannot be empty
                                                            </span>
                                                        )}
                                                    </>
                                                ) : (
                                                    <p className="form-input">{eqpCategoryView}</p>
                                                )}
                                            </div>

                                            {isEquipmentEdit || equipNameView ? (
                                                <div className="form-field-client">
                                                    <label htmlFor="description" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={Name} alt="usericon" />
                                                        </div>
                                                        Name
                                                    </label>
                                                    {isEquipmentEdit ? (
                                                        <input
                                                            type="text"
                                                            id="equipName"
                                                            name="equipName"
                                                            className="form-input"
                                                            value={equipNameEdit}
                                                            onChange={(e) => setEquipNameEdit(e.target.value)}
                                                            required
                                                        />
                                                    ) : (
                                                        <p className="form-textarea">
                                                            {equipNameView}
                                                        </p>
                                                    )}
                                                </div>
                                            ) : null}

                                            {isEquipmentEdit || purchaseDateView ? (
                                                <div className="form-field-client">
                                                    <label htmlFor="time" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={birthIcon} alt="usericon" />
                                                        </div>
                                                        Purchase Date
                                                    </label>
                                                    {isEquipmentEdit ? (
                                                        <>
                                                            <div className="date-picker-outer date-picker-outer-all">
                                                                <div className="custoom-icon-calender custoom-icon-calender-all" ref={purchaseDateEditRef}>
                                                                    <DatePicker
                                                                        oneTap
                                                                        format="dd/MM/yyyy"
                                                                        ranges={ranges}
                                                                        value={purchaseDateEdit}
                                                                        onChange={handleDateEditChange}
                                                                        placement="auto"
                                                                        className="invoice-filter-top-date"
                                                                        isoWeek={appSettings.weekStartDay && appSettings.weekStartDay === 'Monday'}
                                                                        timeZone={global.config.getTimeZone()}
                                                                        disabledDate={disabledDate}
                                                                    />
                                                                </div>
                                                                <div className="custom-picker-icon custom-picker-icon-all">
                                                                    <svg
                                                                        width="1em"
                                                                        height="1em"
                                                                        viewBox="0 0 14 14"
                                                                        fill="currentColor"
                                                                        aria-hidden="true"
                                                                        focusable="false"
                                                                        class="rs-picker-toggle-caret rs-icon"
                                                                        aria-label="calendar"
                                                                        data-category="legacy"
                                                                    >
                                                                        <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                                                                    </svg>
                                                                </div>
                                                            </div>

                                                            {purchseDateEditIsValid && (
                                                                <span className="text-red-500 text-xs italic">
                                                                    Select the Purchase date
                                                                </span>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <p className="form-input">{purchaseDateView}</p>
                                                    )}
                                                </div>
                                            ) : null}

                                            <div className="form-field-client">
                                                {isEquipmentEdit || assignedUserView ? (
                                                    <label htmlFor="category" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={UserIcon} alt="usericon" />
                                                        </div>
                                                        Assigned User
                                                    </label>
                                                ) : null}
                                                {isEquipmentEdit ? (
                                                    <>
                                                        {(isLoadingUser == true || isLoadingActiveUser) ? (
                                                            <div className="outter-load-table">
                                                                <ThreeDots
                                                                    height="18"
                                                                    width="20"
                                                                    radius="9"
                                                                    color="#405BFF"
                                                                    ariaLabel="three-dots-loading"
                                                                    wrapperStyle={{}}
                                                                    wrapperClassName=""
                                                                    visible={true}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div ref={assignedUserSelectEditDropdownRef} className={`cursor ${assignedUserEditDropdownOpen ? 'open' : ''}`} >
                                                                <span
                                                                    id="user-select"
                                                                    onClick={handleToggleAssignedUserEditDropdown}
                                                                    className={`custom-dropdown-user-new custom-dropdown-user user-equipment ${assignedUserEditIsValid ? 'input-validation-error' : ''}`}
                                                                    ref={assignedUserEditRef}
                                                                >
                                                                    {assignedUserEdit ? (
                                                                        userIds?.find((user) => user._id === assignedUserEdit)?.first_name ? (
                                                                            <>
                                                                                {userIds?.find((user) => user._id === assignedUserEdit)?.first_name}{' '}
                                                                                {userIds?.find((user) => user._id === assignedUserEdit)?.middle_name &&
                                                                                    userIds?.find((user) => user._id === assignedUserEdit)?.middle_name !== 'null'
                                                                                    ? userIds?.find((user) => user._id === assignedUserEdit)?.middle_name + ' '
                                                                                    : ''}
                                                                                {userIds?.find((user) => user._id === assignedUserEdit)?.last_name}{' '}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {userIds.find((user) => user._id === assignedUserEdit)?.company_first_name
                                                                                    ? `${userIds.find((user) => user._id === assignedUserEdit)?.company_first_name} ${userIds.find((user) => user._id === assignedUserEdit)?.company_last_name
                                                                                        ? userIds.find((user) => user._id === assignedUserEdit)?.company_last_name
                                                                                        : ''
                                                                                    }`
                                                                                    : `${userIds.find((user) => user._id === assignedUserEdit)?.company_name || ''}(Company)`}
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        'Select Assigned User'
                                                                    )}
                                                                </span>
                                                                {assignedUserEditDropdownOpen && (
                                                                    <div className="custom-dropdown-new">
                                                                        <input
                                                                            type="text"
                                                                            className="search-bar"
                                                                            placeholder="Search..."
                                                                            value={userSearchTerm}
                                                                            onChange={handleAssignedUserSearchInputChange}
                                                                        />
                                                                        <ul className="client-list">
                                                                            {filteredUsers.length > 0 &&
                                                                                filteredUsers
                                                                                    .slice()
                                                                                    .sort((a, b) => {
                                                                                        const nameA = a.first_name
                                                                                            ? `${a.first_name} ${a.middle_name || ''} ${a.last_name}`
                                                                                            : `${a.company_first_name ? a.company_first_name + (a.company_last_name && a.company_last_name) : a.company_name}`;
                                                                                        const nameB = b.first_name
                                                                                            ? `${b.first_name} ${b.middle_name || ''} ${b.last_name}`
                                                                                            : `${b.company_first_name ? b.company_first_name + (b.company_last_name && b.company_last_name) : b.company_name}`;
                                                                                        return nameA.localeCompare(nameB);
                                                                                    })
                                                                                    .map((item) => (
                                                                                        <li key={item._id} className={assignedUserEdit === item._id ? 'selected-item' : ''} onClick={() => handleSelectAssignedUserEdit(item._id)}>
                                                                                            {item.first_name ? (
                                                                                                <>
                                                                                                    {item.first_name}{' '}
                                                                                                    {item.middle_name && item.middle_name !== 'null' ? item.middle_name + ' ' : ''}
                                                                                                    {item.last_name}{' '}
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    {item.company_first_name
                                                                                                        ? `${item.company_first_name} ${item.company_last_name ? item.company_last_name : ''}`
                                                                                                        : `${item.company_name || ''}(Company)`}
                                                                                                </>
                                                                                            )}
                                                                                        </li>
                                                                                    ))
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                        {assignedUserEditIsValid && (
                                                            <span className="text-red-500 text-xs italic">
                                                                Assigned User needs to be selected
                                                            </span>
                                                        )}
                                                    </>
                                                ) : (
                                                    <p className="form-input">
                                                        {isLoadingUser == true ? (
                                                            <div className="outter-load-table">
                                                                <ThreeDots
                                                                    height="18"
                                                                    width="20"
                                                                    radius="9"
                                                                    color="#405BFF"
                                                                    ariaLabel="three-dots-loading"
                                                                    wrapperStyle={{}}
                                                                    wrapperClassName=""
                                                                    visible={true}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className="expense-assigned-user-outer">
                                                                <span className="user-image-expense">
                                                                    {assignedUserView && userIds?.find((user) => user._id === assignedUserView)?.profile_image !== null &&
                                                                        userIds?.find((user) => user._id === assignedUserView)?.profile_image !== "null" ? (
                                                                        <img
                                                                            src={`/uploads/lowProfileImage/${userIds?.find((user) => user._id === assignedUserView)?.profile_image}`}
                                                                            alt={assignedUserView ? (
                                                                                userIds?.find((user) => user._id === assignedUserView)?.first_name ? (
                                                                                    <>
                                                                                        {userIds?.find((user) => user._id === assignedUserView)?.first_name}{' '}
                                                                                        {userIds?.find((user) => user._id === assignedUserView)?.middle_name &&
                                                                                            userIds?.find((user) => user._id === assignedUserView)?.middle_name !== 'null'
                                                                                            ? userIds?.find((user) => user._id === assignedUserView)?.middle_name + ' '
                                                                                            : ''}
                                                                                        {userIds?.find((user) => user._id === assignedUserView)?.last_name}{' '}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        {userIds.find((user) => user._id === assignedUserView)?.company_first_name
                                                                                            ? `${userIds.find((user) => user._id === assignedUserView)?.company_first_name} ${userIds.find((user) => user._id === assignedUserView)?.company_last_name
                                                                                                ? userIds.find((user) => user._id === assignedUserView)?.company_last_name
                                                                                                : ''
                                                                                            }`
                                                                                            : `${userIds.find((user) => user._id === assignedUserView)?.company_name || ''}(Company)`}
                                                                                    </>
                                                                                )
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                            onError={(e) => {
                                                                                e.target.onerror = null;
                                                                                e.target.src = "/uploads/lowProfileImage/user_default.png";
                                                                            }}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={profile_image}
                                                                            alt={assignedUserView ? (
                                                                                userIds?.find((user) => user._id === assignedUserView)?.first_name ? (
                                                                                    <>
                                                                                        {userIds?.find((user) => user._id === assignedUserView)?.first_name}{' '}
                                                                                        {userIds?.find((user) => user._id === assignedUserView)?.middle_name &&
                                                                                            userIds?.find((user) => user._id === assignedUserView)?.middle_name !== 'null'
                                                                                            ? userIds?.find((user) => user._id === assignedUserView)?.middle_name + ' '
                                                                                            : ''}
                                                                                        {userIds?.find((user) => user._id === assignedUserView)?.last_name}{' '}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        {userIds.find((user) => user._id === assignedUserView)?.company_first_name
                                                                                            ? `${userIds.find((user) => user._id === assignedUserView)?.company_first_name} ${userIds.find((user) => user._id === assignedUserView)?.company_last_name
                                                                                                ? userIds.find((user) => user._id === assignedUserView)?.company_last_name
                                                                                                : ''
                                                                                            }`
                                                                                            : `${userIds.find((user) => user._id === assignedUserView)?.company_name || ''}(Company)`}
                                                                                    </>
                                                                                )
                                                                            ) : (
                                                                                ''
                                                                            )}
                                                                        />
                                                                    )}
                                                                </span>
                                                                <div className="expense-assigned-user-inner">
                                                                    {assignedUserView ? (
                                                                        userIds?.find((user) => user._id === assignedUserView)?.first_name ? (
                                                                            <>
                                                                                {userIds?.find((user) => user._id === assignedUserView)?.first_name}{' '}
                                                                                {userIds?.find((user) => user._id === assignedUserView)?.middle_name &&
                                                                                    userIds?.find((user) => user._id === assignedUserView)?.middle_name !== 'null'
                                                                                    ? userIds?.find((user) => user._id === assignedUserView)?.middle_name + ' '
                                                                                    : ''}
                                                                                {userIds?.find((user) => user._id === assignedUserView)?.last_name}{' '}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                {userIds.find((user) => user._id === assignedUserView)?.company_first_name
                                                                                    ? `${userIds.find((user) => user._id === assignedUserView)?.company_first_name} ${userIds.find((user) => user._id === assignedUserView)?.company_last_name
                                                                                        ? userIds.find((user) => user._id === assignedUserView)?.company_last_name
                                                                                        : ''
                                                                                    }`
                                                                                    : `${userIds.find((user) => user._id === assignedUserView)?.company_name || ''}(Company)`}
                                                                            </>
                                                                        )
                                                                    ) : (
                                                                        ''
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </p>
                                                )}
                                            </div>

                                            {isEquipmentEdit || serialNumberView ? (
                                                <div className="form-field-client">
                                                    <label htmlFor="serialNumberEdit" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={SerialNumber} alt="usericon" />
                                                        </div>
                                                        Serial Number
                                                    </label>
                                                    {isEquipmentEdit ? (
                                                        <>
                                                            <input
                                                                type="text"
                                                                id="serialNumberEdit"
                                                                name="serialNumberEdit"
                                                                className="form-input"
                                                                value={serialNumberEdit}
                                                                onChange={(e) => setSerialNumberEdit(e.target.value)}
                                                                ref={serialNumberEditRef}
                                                                required
                                                            />

                                                            {serialNumberEditIsValid && (
                                                                <span className="text-red-500 text-xs italic">
                                                                    Serial number cannot be empty
                                                                </span>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <p className="form-textarea">
                                                            {serialNumberView}
                                                        </p>
                                                    )}
                                                </div>
                                            ) : null}

                                            {isEquipmentEdit || quantityView ? (
                                                <div className="form-field-client">
                                                    <label htmlFor="quantityEdit" className="form-label">
                                                        <div className="icon-before-time">
                                                        <img src={Quantity} alt="Quantity" />
                                                        </div>
                                                        Quantity
                                                    </label>
                                                    {isEquipmentEdit ? (
                                                        <>
                                                            <input
                                                                type="number"
                                                                id="quantityEdit"
                                                                name="quantityEdit"
                                                                className="form-input"
                                                                value={quantityEdit}
                                                                onChange={(e) => setQuantityEdit(e.target.value)}
                                                                ref={quantityEditRef}
                                                                required
                                                                onWheel={numberInputOnWheelPreventChange}
                                                            />
                                                            {quantityEditIsValid && (
                                                                <span className="text-red-500 text-xs italic">
                                                                    Quantity cannot be empty
                                                                </span>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <p className="form-textarea">
                                                            {quantityView}
                                                        </p>
                                                    )}
                                                </div>
                                            ) : null}

                                            <div className="form-field-client">
                                                {isEquipmentEdit || eqpStatusView ? (
                                                    <label htmlFor="category" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={Status} alt="Status" />
                                                        </div>
                                                        Status
                                                    </label>
                                                ) : null}
                                                {isEquipmentEdit ? (
                                                    <div className="custom-dropdown" ref={eqpStatusEditRef}>
                                                        <div ref={eqpStatusEditDropdownRef} className={`custom-dropdown-user-new-outer custom-dropdown-select ${eqpStatusEditDropdownOpen ? 'open' : ''} ${eqpStatusEditIsValid ? 'input-validation-error' : ''}`}>
                                                            <div className="selected-option custom-dropdown-user-new" onClick={handleEqpStatusEditToggleDropdown}>
                                                                {eqpStatusEdit ? eqpStatusEdit : 'Select Type'}
                                                            </div>
                                                            {eqpStatusEditDropdownOpen && (
                                                                <div className="custom-dropdown-new">
                                                                    <ul className="type-list">
                                                                        <li className={eqpStatusEdit === 'In Progress' ? 'selected-item' : ''} onClick={() => handleEqpStatusEditSelectOption('Purchased')}>Purchased</li>
                                                                        <li className={eqpStatusEdit === 'Cancelled' ? 'selected-item' : ''} onClick={() => handleEqpStatusEditSelectOption('Appointed')}>Appointed</li>
                                                                        <li className={eqpStatusEdit === 'Delivered' ? 'selected-item' : ''} onClick={() => handleEqpStatusEditSelectOption('Returned')}>Returned</li>
                                                                        <li className={eqpStatusEdit === 'Delivered' ? 'selected-item' : ''} onClick={() => handleEqpStatusEditSelectOption('Depreciated')}>Depreciated</li>
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <span className="custom-arrow"></span>
                                                    </div>
                                                ) : (
                                                    <p className="form-input">{eqpStatusView}</p>
                                                )}
                                                {eqpStatusEditIsValid && (
                                                    <span className="text-red-500 text-xs italic">
                                                        Equipment status needs to be selected
                                                    </span>
                                                )}
                                            </div>

                                            {isEquipmentEdit || eqpReceiptFileNameView.length > 0 ? (
                                                <div className="form-field-client form-field-client-full">
                                                    <label htmlFor="quantityEdit" className="form-label">
                                                        <div className="icon-before-time">
                                                            <img src={Receipt} alt="Receipt" />
                                                        </div>
                                                        Receipt
                                                    </label>
                                                    {isEquipmentEdit ? (
                                                        <div className={`file-input-wrapper equipment-doc-download equipment-doc-download-edit ${(eqpReceiptFileNameEdit.length > 0 || eqpReceiptFilesEdit.length > 0) ? 'equipment-doc-download-create-active' : ''}`}>
                                                            {(eqpReceiptFileNameEdit.length > 0 || eqpReceiptFilesEdit.length > 0) ? (
                                                                <div className="upload-file-name-br">
                                                                    {eqpReceiptFileNameEdit.map((file, index) => (
                                                                        <div className="the-src-pdf-file equipment-doc-download">
                                                                            <div className="bottom-download-outer">
                                                                                <div className="bottom-download-inner">
                                                                                    <div className="bottom-download-item">
                                                                                        <div className="attachment-file-sib-pname">
                                                                                            <span className="shortened-name" title={file}>{file}</span>
                                                                                        </div>
                                                                                        <div className="attachment-file-sib-psize">{file && getFileExtension(file)?.toUpperCase()}{"     "}
                                                                                            {eqpReceiptFileSizeView && eqpReceiptFileSizeView[index] && (
                                                                                                <span>{eqpReceiptFileSizeView[index]}</span>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="bottom-download-inner-right" onClick={() => handleRemoveFile(file, index)}>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                                                        <path d="M16.9576 19.6445L17.4362 4.37763H19.577V3.85209H14.0107V2.45942C14.0107 1.69739 13.4314 1.09302 12.701 1.09302H7.96587C7.23545 1.09302 6.65615 1.69739 6.65615 2.45942V3.85209H1.08984V4.37763H3.23073L3.70928 19.6445C3.73447 20.354 4.28858 20.9058 4.96863 20.9058H15.6731C16.3783 20.9058 16.9324 20.354 16.9576 19.6445ZM7.15989 2.45942C7.15989 1.98643 7.51251 1.61856 7.96587 1.61856H12.701C13.1544 1.61856 13.507 1.98643 13.507 2.45942V3.85209H7.15989V2.45942ZM4.21302 19.6182L3.73447 4.37763H16.9324L16.4539 19.6182C16.4287 20.0387 16.1012 20.3803 15.6983 20.3803H4.96863C4.56564 20.3803 4.23821 20.0387 4.21302 19.6182Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M15.6736 21H4.96874C4.23877 21 3.64643 20.4064 3.61944 19.6486L3.14359 4.4723H1V3.75907H6.56631V2.46024C6.56631 1.64144 7.18114 1 7.96598 1H12.7011C13.486 1 14.1008 1.64144 14.1008 2.46024V3.75907H19.6671V4.4723H17.5231L17.0504 19.5515H17.0508L17.0472 19.6486C17.0202 20.4064 16.4166 21 15.6732 21H15.6736ZM1.17991 4.28414H3.3181L3.79935 19.6416C3.82273 20.2976 4.33637 20.8118 4.96874 20.8118H15.6736C16.3267 20.8118 16.8376 20.3149 16.8673 19.6538V19.6416L17.349 4.28414H19.4872V3.9463H13.9209V2.45978C13.9209 1.74608 13.3852 1.18722 12.7011 1.18722H7.96598C7.28189 1.18722 6.74622 1.74608 6.74622 2.45978V3.9463H1.17991V4.28414ZM4.96874 20.4745C4.52347 20.4745 4.15196 20.101 4.12363 19.6242V19.6214L3.64193 4.28367H17.0256L16.5439 19.6214C16.5151 20.101 16.1441 20.474 15.6984 20.474H4.96874V20.4745ZM4.30308 19.6139C4.32647 19.9912 4.61837 20.2868 4.96874 20.2868H15.6984C16.0492 20.2868 16.3415 19.9907 16.364 19.6125L16.8394 4.47137H3.82723L4.30263 19.6134L4.30308 19.6139ZM13.5971 3.9463H7.07005V2.45978C7.07005 1.93565 7.46359 1.52507 7.96598 1.52507H12.7011C13.2035 1.52507 13.5971 1.93565 13.5971 2.45978V3.9463ZM7.24995 3.7586H13.4172V2.45978C13.4172 2.04075 13.1028 1.71276 12.7011 1.71276H7.96598C7.56434 1.71276 7.24995 2.04075 7.24995 2.45978V3.7586Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M10.0811 8.37158H10.5848V16.2284H10.0811V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M10.6749 16.3223H9.99121V8.27783H10.6749V16.3223ZM10.1711 16.1346H10.4949V8.46552H10.1711V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M7.05859 8.37158H7.56233V16.2284H7.05859V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M7.65239 16.3223H6.96875V8.27783H7.65239V16.3223ZM7.14866 16.1346H7.47249V8.46552H7.14866V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M13.1045 8.37158H13.6082V16.2284H13.1045V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        <path d="M13.6983 16.3223H13.0146V8.27783H13.6983V16.3223ZM13.1946 16.1346H13.5184V8.46552H13.1946V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                    </svg>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                    {eqpReceiptFilesEdit.map((file, index) => (
                                                                        <div key={index} className="uploaded-file-item">
                                                                            <div className="the-src-pdf-file equipment-doc-download">
                                                                                <div className="bottom-download-outer">
                                                                                    <div className="bottom-download-inner">
                                                                                        <div className="bottom-download-item">
                                                                                            <div className="attachment-file-sib-pname">
                                                                                                <span className="shortened-name" title={file.name}>{file.name}</span>
                                                                                            </div>
                                                                                            <div className="attachment-file-sib-psize">{file.name && file.name.split('.').pop()?.toUpperCase()}{"     "} <span>127.2 KB</span></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="bottom-download-inner-right" onClick={() => removeEditFile(index)}>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22" fill="none">
                                                                                            <path d="M16.9576 19.6445L17.4362 4.37763H19.577V3.85209H14.0107V2.45942C14.0107 1.69739 13.4314 1.09302 12.701 1.09302H7.96587C7.23545 1.09302 6.65615 1.69739 6.65615 2.45942V3.85209H1.08984V4.37763H3.23073L3.70928 19.6445C3.73447 20.354 4.28858 20.9058 4.96863 20.9058H15.6731C16.3783 20.9058 16.9324 20.354 16.9576 19.6445ZM7.15989 2.45942C7.15989 1.98643 7.51251 1.61856 7.96587 1.61856H12.701C13.1544 1.61856 13.507 1.98643 13.507 2.45942V3.85209H7.15989V2.45942ZM4.21302 19.6182L3.73447 4.37763H16.9324L16.4539 19.6182C16.4287 20.0387 16.1012 20.3803 15.6983 20.3803H4.96863C4.56564 20.3803 4.23821 20.0387 4.21302 19.6182Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M15.6736 21H4.96874C4.23877 21 3.64643 20.4064 3.61944 19.6486L3.14359 4.4723H1V3.75907H6.56631V2.46024C6.56631 1.64144 7.18114 1 7.96598 1H12.7011C13.486 1 14.1008 1.64144 14.1008 2.46024V3.75907H19.6671V4.4723H17.5231L17.0504 19.5515H17.0508L17.0472 19.6486C17.0202 20.4064 16.4166 21 15.6732 21H15.6736ZM1.17991 4.28414H3.3181L3.79935 19.6416C3.82273 20.2976 4.33637 20.8118 4.96874 20.8118H15.6736C16.3267 20.8118 16.8376 20.3149 16.8673 19.6538V19.6416L17.349 4.28414H19.4872V3.9463H13.9209V2.45978C13.9209 1.74608 13.3852 1.18722 12.7011 1.18722H7.96598C7.28189 1.18722 6.74622 1.74608 6.74622 2.45978V3.9463H1.17991V4.28414ZM4.96874 20.4745C4.52347 20.4745 4.15196 20.101 4.12363 19.6242V19.6214L3.64193 4.28367H17.0256L16.5439 19.6214C16.5151 20.101 16.1441 20.474 15.6984 20.474H4.96874V20.4745ZM4.30308 19.6139C4.32647 19.9912 4.61837 20.2868 4.96874 20.2868H15.6984C16.0492 20.2868 16.3415 19.9907 16.364 19.6125L16.8394 4.47137H3.82723L4.30263 19.6134L4.30308 19.6139ZM13.5971 3.9463H7.07005V2.45978C7.07005 1.93565 7.46359 1.52507 7.96598 1.52507H12.7011C13.2035 1.52507 13.5971 1.93565 13.5971 2.45978V3.9463ZM7.24995 3.7586H13.4172V2.45978C13.4172 2.04075 13.1028 1.71276 12.7011 1.71276H7.96598C7.56434 1.71276 7.24995 2.04075 7.24995 2.45978V3.7586Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M10.0811 8.37158H10.5848V16.2284H10.0811V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M10.6749 16.3223H9.99121V8.27783H10.6749V16.3223ZM10.1711 16.1346H10.4949V8.46552H10.1711V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M7.05859 8.37158H7.56233V16.2284H7.05859V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M7.65239 16.3223H6.96875V8.27783H7.65239V16.3223ZM7.14866 16.1346H7.47249V8.46552H7.14866V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M13.1045 8.37158H13.6082V16.2284H13.1045V8.37158Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                            <path d="M13.6983 16.3223H13.0146V8.27783H13.6983V16.3223ZM13.1946 16.1346H13.5184V8.46552H13.1946V16.1346Z" fill="#282828" stroke="#282828" stroke-width="0.5" />
                                                                                        </svg>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            ) : (
                                                                <input
                                                                    type="text"
                                                                    className="form-input form-input-file"
                                                                    value={eqpReceiptFileNameView}
                                                                    readOnly
                                                                />
                                                            )}
                                                            <input
                                                                type="file"
                                                                id="receiptFileEdit"
                                                                name="receiptFileEdit"
                                                                style={{ display: 'none' }}
                                                                ref={eqpReceiptEditRef}
                                                                className="form-input hidden-input"
                                                                onChange={handleReceiptFileEditUpload}
                                                                multiple
                                                            // required
                                                            />
                                                            <label
                                                                htmlFor="receiptFileEdit"
                                                                className="file-input-label"
                                                            >
                                                                <img src={Plus} alt="Browse" />Browse
                                                            </label>
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {eqpReceiptFileNameView.map((file, index) => (
                                                                <p className="form-textarea"
                                                                    onClick={() => downloadEqpReceiptDoc(file)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >
                                                                    <div className="the-src-pdf-file equipment-doc-download">
                                                                        <div className="bottom-download-outer">
                                                                            <div className="bottom-download-inner">
                                                                                <div className="bottom-download-item">
                                                                                    <div className="attachment-file-sib-pname">
                                                                                        <span className="shortened-name" title={file}>{file}</span>
                                                                                    </div>
                                                                                    <div className="attachment-file-sib-psize">{file && getFileExtension(file)?.toUpperCase()}{"     "}
                                                                                        {eqpReceiptFileSizeView && eqpReceiptFileSizeView[index] && (
                                                                                            <span>{eqpReceiptFileSizeView[index]}</span>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="bottom-download-inner-right">
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
                                                                                    <path d="M5.67409 13.8727C5.69551 13.8928 5.71891 13.9108 5.74395 13.9266L5.77888 13.9439L5.82304 13.9665L5.86918 13.9804L5.90971 13.9909C5.97034 14.003 6.03328 14.003 6.09425 13.9909L6.13478 13.9804L6.18091 13.9665L6.22507 13.9439L6.26 13.9266C6.28537 13.9108 6.30877 13.8928 6.33019 13.8727L10.8939 9.57954C11.0458 9.40745 11.0333 9.1549 10.8649 8.99674C10.6965 8.83858 10.4276 8.82682 10.2444 8.9695L6.46134 12.526V1.43331C6.46134 1.19406 6.25473 1 6 1C5.74527 1 5.53865 1.19406 5.53865 1.43331V12.526L1.75563 8.9695C1.57241 8.82682 1.30351 8.83858 1.13512 8.99674C0.966727 9.1549 0.954205 9.40745 1.10612 9.57954L5.67343 13.8727H5.67409Z" fill="#282828" stroke="#282828" stroke-width="0.5"></path>
                                                                                </svg>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </p>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            ) : null}

                                            {isEquipmentEdit ? (
                                                <>
                                                    {isSubmitLoading ?
                                                        (
                                                            <div className="outter-load-table">
                                                                <ThreeDots
                                                                    height="38"
                                                                    width="40"
                                                                    radius="9"
                                                                    color="#6479f9"
                                                                    ariaLabel="three-dots-loading"
                                                                    wrapperStyle={{}}
                                                                    wrapperClassName=""
                                                                    visible={true}
                                                                />
                                                            </div>
                                                        ) : (
                                                            <div className="sprint-btn-outer sprint-btn-outer-expense">
                                                                <button
                                                                    type="button"
                                                                    onClick={handleResetEquipmentEdit}
                                                                    className="submit-client cancel-sprint"
                                                                >
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={handleEqpEditSubmit}
                                                                    className="submit-client save-sprint"
                                                                >
                                                                    Save Changes
                                                                </button>
                                                            </div>
                                                        )}
                                                </>
                                            ) : (
                                                <div className="sprint-btn-outer sprint-btn-outer-expense">
                                                    <button
                                                        type="button"
                                                        className="submit-client cancel-sprint"
                                                        onClick={handleEqpDelete}
                                                        disabled={isSubmitLoading}
                                                    >
                                                        <img src={Delete} alt="Delete" />  Delete
                                                    </button>
                                                    <Modal
                                                        className="delete-modal"
                                                        isOpen={isEqpDeleteModalOpen}
                                                        onRequestClose={handleCancelEqpDelete}
                                                        contentLabel="Confirm Delete"
                                                        style={{
                                                            content: {
                                                                height: "41%",
                                                                width: "30%",
                                                                position: "fixed",
                                                                top: "36%",
                                                                left: "50%",
                                                                transform: "translate(-19.75%, 0%)",
                                                                parent: document.querySelector(".admin-outer.time.tracker"),
                                                            },
                                                        }}
                                                    >
                                                        <div className="delete-modal-content">
                                                            <h2>Confirm Delete</h2>
                                                            <p>
                                                                Are you sure you want to delete this Equipment Data?
                                                            </p>
                                                            <div className="delete-modal-buttons">
                                                                <button className="buttons-rejected" onClick={handleConfirmEqpDelete} disabled={isSubmitLoading}>
                                                                    {isSubmitLoading ?
                                                                        <div className="outter-load-table">
                                                                            <ThreeDots
                                                                                height="18"
                                                                                width="20"
                                                                                radius="9"
                                                                                color="white"
                                                                                ariaLabel="three-dots-loading"
                                                                                wrapperStyle={{}}
                                                                                wrapperClassName=""
                                                                                visible={true}
                                                                            />
                                                                        </div> : "Delete"}
                                                                </button>
                                                                <button onClick={handleCancelEqpDelete} disabled={isSubmitLoading}>
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </Modal>
                                                    <button
                                                        type="button"
                                                        onClick={handleSetEquipmentEdit}
                                                        className="submit-client save-sprint"
                                                    >
                                                        <img alt="" src={editImage} />{" "}
                                                        Edit Equipment Details
                                                    </button>
                                                </div>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        <div className="search-sec">
                            <div class="search-container">
                                <input
                                    type="text"
                                    onChange={handleFilterChange}
                                    value={filter}
                                    class="search-input"
                                    placeholder="Search"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="overview-top-right client-document-outer-top-section equipment-overview" >
                        <div className="showing-count showing-count-timeoff">
                            <div className="filter-inner showing-result show-result-team-fill">
                                <label>Showing</label>

                                <div ref={showingDropdownRef} className="select-modal-mainM custom-dropdown-user-new-outer">
                                    <div className="selected-option custom-dropdown-user-new" onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}>
                                        {totalResults < 10 ? totalResults.toString() : rowsPerPage.toString()}
                                    </div>
                                    {showingDropdownOpen && (
                                        <div className="custom-dropdown-new">
                                            <ul className="showing-options-list">
                                                {totalResults >= 10 && <li className={rowsPerPage === 10 ? 'selected-item' : ''} onClick={() => { setRowsPerPage(10); setCurrentPage(0); setShowingDropdownOpen(false); }}>10</li>}
                                                {totalResults >= 20 && <li className={rowsPerPage === 20 ? 'selected-item' : ''} onClick={() => { setRowsPerPage(20); setCurrentPage(0); setShowingDropdownOpen(false); }}>20</li>}
                                                {totalResults >= 30 && <li className={rowsPerPage === 30 ? 'selected-item' : ''} onClick={() => { setRowsPerPage(30); setCurrentPage(0); setShowingDropdownOpen(false); }}>30</li>}
                                                {totalResults >= 40 && <li className={rowsPerPage === 40 ? 'selected-item' : ''} onClick={() => { setRowsPerPage(40); setCurrentPage(0); setShowingDropdownOpen(false); }}>40</li>}
                                                {totalResults >= 10 && <li className={totalResults >= 10 && rowsPerPage === totalResults ? 'selected-item' : ''} onClick={() => { setRowsPerPage(totalResults); setCurrentPage(0); setShowingDropdownOpen(false); }}>ALL</li>}
                                                {/* Add more conditions as needed */}
                                                {totalResults < 10 ? (
                                                    <li className={totalResults < 10 ? 'selected-item' : ''} onClick={() => { setRowsPerPage(totalResults); setCurrentPage(0); setShowingDropdownOpen(false); }}>{totalResults}</li>
                                                ) : null}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                                <label>of {totalResults} Results</label>
                            </div>
                        </div>

                    </div>


                    {isFetchingEquipment == true ? (
                        <div className="outter-load-table">
                            <ThreeDots
                                height="80"
                                width="80"
                                radius="9"
                                color="#405BFF"
                                ariaLabel="three-dots-loading"
                                wrapperStyle={{}}
                                wrapperClassName=""
                                visible={true}
                            />
                        </div>
                    ) : (
                        <div className="datatable-team-maintb">
                            <DataTable
                                value={filteredData}
                                removableSort
                                tableStyle={{ minWidth: "50rem", width: "100%", textAlign: "left" }}
                                paginator={filteredData.length > 10}
                                paginatorClassName="recent-invoices-pagination"
                                rows={rowsPerPage}
                                first={currentPage * rowsPerPage}
                                onPage={onPageChange}
                                emptyMessage="No Equipment data found"
                            >
                                <Column
                                    field="eqp_id"
                                    header="Equipment ID"
                                    sortable
                                    style={{ width: "19.5%", paddingRight: "20px" }}
                                ></Column>
                                <Column
                                    field="eqp_category.eqp_category_name"
                                    header="Category"
                                    body={useRenderEqpCategory}
                                    sortable
                                    style={{ width: "16.4%", paddingRight: "20px" }}
                                ></Column>
                                <Column
                                    field="eqp_name"
                                    header="Name"
                                    body={(rowData) => (
                                        <TruncateFieldView textContent={rowData.eqp_name} />
                                    )}
                                    sortable
                                    style={{ width: "19%", paddingRight: "20px" }}
                                ></Column>
                                <Column
                                    field="purchase_at"
                                    body={convertPurchaseDate}
                                    header="Purchase Date"
                                    sortable
                                    style={{ width: "20.4%", paddingRight: "20px" }}
                                ></Column>
                                <Column
                                    field="assign_user"
                                    body={useRenderAssignUser}
                                    header="Assigned User"
                                    sortable
                                    style={{ minWidth: "300px", paddingRight: "20px" }}
                                ></Column>
                                <Column
                                    field="_id"
                                    body={detailCTA}
                                    style={{ paddingRight: "20px" }}
                                ></Column>
                            </DataTable>
                        </div>
                    )}
                </div>
            </div>
        </motion.div>
    );
};

export default Equipment;